import React from 'react'

import Icon from 'gatsby-theme-mdx-suite-base/src/components/icon'

const Social = (props) => (
  <a
    href="https://github.com/axe312ger/gatsby-mdx-suite"
    target="_blank"
    rel="noreferrer"
    {...props}
  >
    <Icon icon="github" title="Find us on GitHub" />
  </a>
)

export default Social
